import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'
import { useTranslation } from 'react-i18next'
import { showAlert } from '../../../utility/SweetAlert'

const InteractorAuthenticationOTP = () => {
  const { t } = useTranslation()

  const OTPRequest = useCallback(
    (payload, callback = () => {}, loadingCallback = () => {}) => {
      payload = {
        ...payload,
      }
      loadingCallback(true)
      ApiService.jsonRequest('/auth-otp/request', payload, (response) => {
        loadingCallback(false)
        if (response.status_code === 200 || response.messages === 'please_try_again_in_5_minutes') {
          if (response.messages === 'please_try_again_in_5_minutes') {
            showAlert({
              icon: 'error',
              message: t(`response_message.${response.messages}`),
              timer: 2000,
            })
          } else {
            showAlert({
              icon: 'success',
              message: t(`response_message.please_check_your_email`),
              timer: 2000,
            })
          }
          callback(response)
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: 2000,
          })
        }
      })
    },
    [t],
  )

  const OTPVerify = useCallback(
    (payload, callback) => {
      payload = {
        ...payload,
      }
      ApiService.jsonRequest('/auth-otp/verify', payload, (response) => {
        if (response.status_code === 200) {
          callback()
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: 2000,
          })
        }
      })
    },
    [t],
  )

  return { OTPRequest, OTPVerify }
}

export default InteractorAuthenticationOTP
